import { Box, styled, Tab, Tabs, Typography } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const Icon = styled(Box)(() => ({
  display: "flex",
  svg: { width: pxToRem(20) },
}));

export const SidebarWrapper = styled(Box)(() => ({
  height: "100%",
  flex: 1,
  position: "relative",
}));

export const TabWrapper = styled(Tab)(({ theme }) => ({
  color: theme.palette.colorsBase.gray_10,
  svg: {
    path: {
      fill: theme.palette.text.textLink,
    },
    rect: {
      fill: theme.palette.text.textLink,
    },
  },
  "&.Mui-selected": {
    color: theme.palette.text.textWhite,
    background: theme.palette.colorsBase.blue_0,
    borderRadius: theme.borders.borderRadius.lg_8,
    svg: {
      path: {
        fill: theme.palette.text.textLink,
      },
      rect: {
        fill: theme.palette.text.textLink,
      },
    },
    ".label": {
      border: "none",
    },
  },
  "&:last-child .label": {
    border: "none",
  },
}));

export const TabsCustom = styled(Tabs)(({ theme }) => ({
  width: "100%",
  ".MuiTabs-flexContainer": {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  ".MuiTabs-indicator": {
    display: "none",
  },
  ".MuiTabs-scrollButtons": {
    width: pxToRem(0),
  },
  button: {
    width: "100%",
    alignItems: "baseline",
    padding: `0 ${pxToRem(16)}`,
    opacity: 1,
    div: {
      padding: 0,
    },
  },
}));

export const TabCustom = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
  gap: pxToRem(12),
  padding: `0 ${pxToRem(20)}`,
  fontSize: `${theme.typography.size.md_16}`,
  lineHeight: theme.typography.lineHeight.sm,
  fontWeight: theme.typography.fw_semibold_500,
}));

export const IconLayout = styled(Box)(({ theme }) => ({
  width: pxToRem(24),
  height: pxToRem(24),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "100px",
  color: theme.palette.colorsBase.blue_3,
  background: theme.palette.colorsBase.blue_10,
  fontSize: `${theme.typography.h6}`,
  fontWeight: theme.typography.fw_semibold_600,
  lineHeight: theme.typography.lineHeight.sm,
}));

export const Label = styled(Box)(({ theme }) => ({
  display: "flex",
  flex: 1,
  fontSize: `${theme.typography.size.md_16}`,
  fontWeight: theme.typography.fw_semibold_500,
  lineHeight: theme.typography.lineHeight.sm,
  borderBottom: `1px solid ${theme.palette.stroke.strokeDefault2}`,

  paddingTop: `${pxToRem(16)} !important`,
  paddingBottom: `${pxToRem(16)} !important`,
  textAlign: "left",
}));

export const BoxIcon = styled(Box)(({ theme }) => ({
  svg: {
    transform: "rotate(-90deg)",
    path: {
      fill: theme.palette.text.textLink,
    },
  },
}));

export const BackgroundWrap = styled("div")(({ theme }) => ({
  position: "absolute",
  right: theme.functions.pxToRem(25),
  bottom: -4,
  pointerEvents: "none",
}));

export const BackgroundItemWrap = styled("div")(({ theme }) => ({
  position: "absolute",
  right: theme.functions.pxToRem(70),
  bottom: -4,
}));

export const TitleReport = styled("div")<{ rowOfTitle?: number }>(
  ({ theme, rowOfTitle }) => ({
    width: "100%",
    fontSize: `${theme.typography.size.md_16}`,
    fontWeight: theme.typography.fw_semibold_600,
    lineHeight: theme.typography.lineHeight.sm,
    display: "-webkit-box",
    "-webkit-line-clamp": rowOfTitle ?? "2",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    "text-overflow": "ellipsis",
    cursor: "pointer",
  })
);

export const CreateDay = styled("div")(({ theme }) => ({
  color: theme.palette.colorsBase.gray_6,
  fontSize: `${theme.typography.size.sm_14}`,
  fontWeight: theme.typography.fw_regular_400,
  lineHeight: theme.typography.lineHeight.sm,
  flex: 1,
}));

export const Content = styled(Box)(() => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
}));

export const BottomBox = styled(Box)(() => ({
  display: "flex",
  width: "100%",
  flex: 1,
  alignItems: "flex-end",
}));

export const Action = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: pxToRem(28),
  height: pxToRem(28),
  background: theme.palette.colorsBase.blue_10,
  borderRadius: theme.borders.borderRadius.md_4,
  cursor: "pointer",
}));

export const ReportBox = styled(Box)(({ theme }) => ({
  cursor: "pointer",
  display: "flex",
  position: "relative",
  flexGrow: 1,
  padding: pxToRem(20),
  background: "linear-gradient(89.44deg, #EEF3FF 1.63%, #FFFFFF 147.88%)",
  height: pxToRem(118),
  borderRadius: theme.borders.borderRadius.xl_12,
  border: `1px solid ${theme.palette.stroke.strokeDefault2}`,
  gap: pxToRem(4),
  transition: "all 200ms ease-in-out",

  ":hover": {
    border: `1px solid ${theme.palette.stroke.strokeBrand}`,
    transform: "scale(1.03)",
  },
}));

export const Header = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  marginBottom: pxToRem(24),
}));

export const SearchArea = styled(Box)(() => ({
  display: "flex",
  flex: 1,
  justifyContent: "end",
  gap: pxToRem(8),
}));

export const TextSearchResult = styled(Typography)(({ theme }) => ({
  paddingLeft: pxToRem(12),
  "& span": {
    color: theme.palette.text.textLink,
    fontSize: `${theme.typography.size.xl_20}`,
  },
}));
